import { Box, AppBar, Toolbar, Typography } from '@mui/material'
import * as React from 'react'
import { Outlet } from 'react-router-dom'
import logo from '../../assets/images/logo-header.png'

const PublicLayout = () => {
	return (
		<Box sx={{ height: '100vh', width: '100vw' }}>
			<AppBar position='fixed' sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<Toolbar sx={{ justifyContent: 'space-between' }}>
					<Typography variant='h6' noWrap component='div'>
						<img src={logo} alt={'Brock Logo'} height={50} />
					</Typography>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Typography variant='h1' noWrap component='h1'>
							Field Management Tool v2.0
						</Typography>
					</div>
				</Toolbar>
			</AppBar>

			<Box
				component='main'
				sx={{
					paddingTop: '64px',
					left: '0px',
					top: '0px',
					position: 'relative',
					height: 'auto',
					width: '100vw',
					overflowY: 'auto',
				}}
			>
				<Outlet />
			</Box>
		</Box>
	)
}

export default PublicLayout
